/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.StaffPaymentInfoResponseDto>
>;
export function request(
  params: API.basics.staffPaymentInfo.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basic/staffPaymentInfo/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
